import React from "react";
import { Tag } from "@plum-xoxo/admin-dsm";

const CategoryTab = ({
  title,
  categories,
  selectedCategory,
  setSelectedCategory,
  setSelectedFilterIndex,
}) => {
  return (
    <div className="d-flex align-items-center">
      {categories.map((category, index) => (
        <Tag
          key={index}
          label={category.title}
          variant={selectedCategory === index ? "status" : "base"}
          className="mr-8 cursor-pointer"
          onClick={() => {
            setSelectedCategory(index);
            setSelectedFilterIndex(-1);
          }}
          style={{
            height: "28px",
          }}
        />
      ))}
    </div>
  );
};

export default CategoryTab;
